import React from 'react';
import css from './BusinessWeServe.module.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import { useState } from 'react';
import Modal from '../Modal/Modal';
import { compose } from 'redux';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { withRouter } from 'react-router-dom';
import modalImg1 from '../../assets/norton-shake.png';
import modalImg2 from '../../assets/shutterstock_1158389167.png';
import modalBusiness from '../../assets/svg/modalBusiness.svg';
import modalWorker from '../../assets/svg/modalWorker.svg';

function BusinessWeServe(props) {
  const { onManageDisableScrolling, history } = props;
  const [open, setOpen] = useState(false);

  const closeAuthModal = () => {
    setOpen(false);
  };
  return (
    <div className={css.BusinessWeServe}>
      <div className={css.heading}>
        <p className={css.heading}>
          <FormattedMessage id="BusinessWeServe.heading" />
        </p>
      </div>
      <div className={css.description}>
        <p className={css.description}>
          <FormattedMessage id="BusinessWeServe.desc" />
          <span className={css.create_acc} onClick={() => setOpen(!open)}>
            {' '}
            <FormattedMessage id="BusinessWeServe.create_acc" />
          </span>
        </p>
      </div>
      <Modal
        id="ContactDetails.showAuthModal"
        isOpen={open}
        onClose={closeAuthModal}
        scrollLayerClassName={css.modalScrollLayer}
        containerClassName={css.modalContainer1}
        contentClassName={css.modalContent}
        onManageDisableScrolling={onManageDisableScrolling}
        usePortal
      >
        <div className={css.modalDiv}>
          <p className={css.modalHeading}>
            <FormattedMessage id="BusinessWeServe.modalHeading" />
          </p>
          <p className={css.accLogin_text}>
            <FormattedMessage id="LandingPage.alreadyAccountMessage" />
            {/* <span className={css.accLogin_text1}>
              {' '} */}
            <span
              className={css.login}
              onClick={e => {
                e.stopPropagation();
                history.push(
                  createResourceLocatorString('LoginPage', routeConfiguration(), {}, {})
                );
              }}
            >
              {' '}
              <FormattedMessage id="LandingPage.logInMessage" />{' '}
            </span>{' '}
            {/* </span>{' '} */}
          </p>
          <div className={css.modalParent}>
            <div className={css.modalChild}>
              <img src={modalImg1} alt="" />
              <div className={css.modalDetail}>
                <img src={modalBusiness} alt="" />
                <p className={css.modaltext}>
                  <FormattedMessage id="BusinessWeServe.modalBusiness" />{' '}
                </p>
                <div className={css.herobuttons}>
                  <span
                    className={css.staff}
                    onClick={e => {
                      e.stopPropagation();
                      history.push(
                        createResourceLocatorString('SignupAsCompanyPage', routeConfiguration(), {}, {})
                      );
                    }}
                  >
                    <FormattedMessage id="LandingPage.buttonStaffMessage" />
                  </span>
                </div>
                {/* <div className='learnMore'>
                  <p>Learn More</p>
                </div> */}
              </div>
              <div className={css.learnMore}>
                <p
                  onClick={e => {
                    e.stopPropagation();
                    history.push(
                      createResourceLocatorString('LookingForStaff', routeConfiguration(), {}, {})
                    );
                  }}
                >
                  <FormattedMessage id="BusinessWeServe.modalLearnMore" />{' '}
                </p>
              </div>
            </div>
            <div className={css.modalChild}>
              <img src={modalImg2} alt="" />
              <div className={css.modalDetail}>
                <img src={modalWorker} alt="" />
                <p className={css.modaltext}>
                  <FormattedMessage id="BusinessWeServe.modalWorker" />{' '}
                </p>
                <div className={css.herobuttons}>
                  <span
                    className={css.work}
                    onClick={e => {
                      e.stopPropagation();
                      history.push(
                        createResourceLocatorString('SignupPage', routeConfiguration(), {}, {})
                      );
                    }}
                  >
                    {' '}
                    <FormattedMessage id="LandingPage.buttonWorkMessage" />
                  </span>
                </div>
              </div>
              <div className={css.learnMore}>
                <p
                  onClick={e => {
                    e.stopPropagation();
                    history.push(
                      createResourceLocatorString('LookingForWork', routeConfiguration(), {}, {})
                    );
                  }}
                >
                  <FormattedMessage id="BusinessWeServe.modalLearnMore" />{' '}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default compose(
  injectIntl,
  withRouter
)(BusinessWeServe);
